import { createNewModel, deleteModel, updateModel } from "../actions/modelAction";
import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  models: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  tripleScreen:{
    region: [],
    sales: [],
    market: [],
    isLoading: false,
    hasError: false
  },
  createNewModel: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateModel: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteModel: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  repText: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  regions: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  currency:{
    data:[],
    isLoading:false,
    hasError:false
  },
  searchValue: "",
  sortBy: "",
  selectedPage: 0,
  isTouched: false,
  showSidePanel: false,
};

export const modelReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.SET_SHOW_SIDE_PANEL:
    return{
      ...newState,
      showSidePanel: action.payload
    }
    case actionTypes.SELECTED_MODEL_PAGE:
    return{
      ...newState,
      selectedPage: action.payload
    }

    case actionTypes.GET_MODELS:
      return {
        ...newState,
        models: { ...newState.models, isLoading: true, hasError: false },
      };
    case actionTypes.GET_MODELS_SUCCESS:
      return {
        ...newState,
        models: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_MODELS_FAILURE:
      return {
        ...newState,
        models: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.GET_REPTEXT:
      return {
        ...newState,
        repText: { ...newState.repText, isLoading: true, hasError: false },
      };
    case actionTypes.GET_REPTEXT_SUCCESS:
      return {
        ...newState,
        repText: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_REPTEXT_FAILURE:
      return {
        ...newState,
        repText: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_MODEL:
      return {
        ...newState,
        createNewModel: { ...newState.createNewModel, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_MODEL_SUCCESS:
      return {
        ...newState,
        createNewModel: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_MODEL_FAILURE:
      return {
        ...newState,
        createNewModel: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_REPTEXT:
      return {
        ...newState,
        updateRepText: { ...newState.updateRepText, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_REPTEXT_SUCCESS:
      return {
        ...newState,
        updateRepText: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_REPTEXT_FAILURE:
      return {
        ...newState,
        updateRepText: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.GET_REGIONS:
      return {
        ...newState,
        regions: { ...newState.regions, isLoading: true, hasError: false },
      };
    case actionTypes.GET_REGIONS_SUCCESS:
      return {
        ...newState,
        regions: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_REGIONS_FAILURE:
      return {
        ...newState,
        regions: { data: action.payload, isLoading: false, hasError: true },
      };
    case actionTypes.GET_REGIONST:
      return{
        ...newState,
        tripleScreen: {...newState.tripleScreen, isLoading: true, hasError: false}
      }  
    case actionTypes.GET_REGIONST_SUCCESS:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen,region: action.payload, isLoading:false, hasError:false}
      }  
    case actionTypes.GET_REGIONST_FAILURE:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen, region:action.payload, isLoading:false, hasError:true}
      }  
    case actionTypes.GET_SALES_OFFICE:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen, isLoading: true, hasError: false}
      }  
    case actionTypes.GET_SALES_OFFICE_SUCCESS:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen, sales:action.payload,market:[], isLoading:false,hasError:false}
      }
    case actionTypes.GET_SALES_OFFICE_FAILURE:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen,sales:action.payload,isLoading:false,hasError:true}
      } 
    case actionTypes.GET_MARKET:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen, isLoading:true,hasError:false}
      }     
    case actionTypes.GET_MARKET_SUCCESS:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen,market:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.GET_MARKET_FAILURE:
      return{
        ...newState,
        tripleScreen:{...newState.tripleScreen,market:action.payload,isLoading:false,hasError:true}
      } 
    case actionTypes.ADD_REGION:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,isLoading:true,hasError:false}
      }   
    case actionTypes.ADD_REGION_SUCCESS:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.ADD_REGION_FAILURE:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:true}
      }
    case actionTypes.DELETE_REGION:
      return{
        ...newState,
        deleteModel:{...newState.deleteModel,isLoading:true,hasError:false}
      }    
    case actionTypes.DELETE_REGION_SUCCESS:
      return{
        ...newState,
        deleteModel:{...newState.deleteModel,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.DELETE_REGION_FAILURE:
      return{
        ...newState,
        deleteModel:{...newState.deleteModel,data:action.payload,isLoading:false,hasError:true}
      }  
    case actionTypes.UPDATE_REGION_SALES_MARKET_START:
      return{
        ...newState,
        updateModel:{...newState.updateModel,isLoading:true,hasError:false}
      }  
    case actionTypes.UPDATE_REGION_SALES_MARKET_SUCCESS:
      return{
        ...newState,
        updateModel:{...newState.updateModel,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.UPDATE_REGION_SALES_MARKET_FAILURE:
      return{
        ...newState,
        updateModel:{...newState.updateModel,data:action.payload,isLoading:false,hasError:true}
      } 
    case actionTypes.ADD_NEW_MARKET_START:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,isLoading:true,hasError:false}
      }  
    case actionTypes.ADD_NEW_MARKET_SUCCESS:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.ADD_NEW_MARKET_FAILURE:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:true}
      }  
    case actionTypes.CURRENCY_FETCH_START:
      return{
        ...newState,
        currency:{...newState.currency,isLoading:true,hasError:false}
      }        
    case actionTypes.CURRENCY_FETCH_SUCCESS:
      return{
        ...newState,
        currency:{...newState.currency,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.CURRENCY_FETCH_FAILURE:
      return{
        ...newState,
        currency:{...newState.currency,data:action.payload,isLoading:false,hasError:true}
      }
    case actionTypes.ADD_NEW_SALES_OFFICE_START:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,isLoading:true,hasError:false}
      }    
    case actionTypes.ADD_NEW_SALES_OFFICE_SUCCESS:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.ADD_NEW_SALES_OFFICE_FAILURE:
      return{
        ...newState,
        createNewModel:{...newState.createNewModel,data:action.payload,isLoading:false,hasError:true}
      }  
    case actionTypes.UPDATE_SALES_OFFICE_STARTED:
      return{
        ...newState,
        updateModel:{...newState.updateModel,isLoading:true,hasError:false}
      } 
    case actionTypes.UPDATE_SALES_OFFICE_SUCCESS:
      return{
        ...newState,
        updateModel:{...newState.updateModel,data:action.payload,isLoading:false,hasError:false}
      }   
    case actionTypes.UPDATE_SALES_OFFICE_FAILURE:
      return{
        ...newState,
        updateModel:{...newState.updateModel,data:action.payload,isLoading:false,hasError:true}
      }  
    default:
      return { ...newState };
  }
};
